import gql from 'graphql-tag'

export const SEND_EMAIL = gql`
  mutation sendEmail(
    $email: String!
  ) {
    sendRecoveryInformation(
      email: $email
    )
  }
`

